import initSliderCards from '../shared/sliderCards';
import initSliderDestination from './slider';

interface DestinationConfig {
  destination: {
    similar: {
      id: string;
      count: number;
    };
    slider: string;
  };
}

export default ({ destination }: DestinationConfig): void => {
  const { similar, slider } = destination;

  initSliderDestination(slider);
  initSliderCards(similar.id, similar.count);
};
